import { Dialog } from 'snap-design-system';
import { useDialogActions, useDialogProps, useIsDialogIsOpen } from '~/store/dialogStore';

export function DialogContainer() {
  const { closeDialog } = useDialogActions();
  const isOpen = useIsDialogIsOpen();
  const dialogProps = useDialogProps();

  const getDialogClassName = () => {
    const { className, maxWidth } = dialogProps || {};

    if (maxWidth) {
      return className ? `${maxWidth} ${className}` : maxWidth;
    }

    return className;
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && closeDialog()}>
      <Dialog.Content
        className={getDialogClassName()}
        showClose={!dialogProps?.hideCloseButton}
        onInteractOutside={dialogProps?.preventOutsideClose ? (e) => e.preventDefault() : undefined}
        onEscapeKeyDown={dialogProps?.preventOutsideClose ? (e) => e.preventDefault() : undefined}
        {...(!dialogProps?.description && { 'aria-describedby': undefined })}
      >
        {dialogProps?.title && (
          <Dialog.Header>
            {dialogProps?.icon && <Dialog.Icon>{dialogProps?.icon}</Dialog.Icon>}
            <Dialog.Title>
              {dialogProps?.title || "Dialog Title"}
            </Dialog.Title>
          </Dialog.Header>
        )}
        <Dialog.Body>
          {dialogProps?.description && (
            <Dialog.Description>
              {dialogProps?.description}
            </Dialog.Description>
          )}
          {dialogProps?.content}
        </Dialog.Body>
        {dialogProps?.footer && (
          <Dialog.Footer>{dialogProps.footer}</Dialog.Footer>
        )}
      </Dialog.Content>
    </Dialog>
  );
}
